import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from '@tanstack/react-router';
import { ConfirmationModal } from '@/components/Modals/ConfirmationModal';

import { type RootState } from '../../store/store';
import LogoDecat from '../../imgs/decat-logo.png';
import LogoILink from '../../imgs/ilink-logo.png';
import { LanguagePicker } from '../LanguagePicker/LanguagePicker';

import './toolbar.scss';

export const Toolbar = () => {
  const userName = useSelector((state: RootState) => state.user.displayName);
  const pathname = useLocation({ select: location => location.pathname });
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const isEditingInWizard = pathname.includes('/associated-services');

  const handleLogoClick = () => {
    if (isEditingInWizard) {
      setShowModal(true);
    } else {
      navigate({ to: '/' }).catch(() => {});
    }
  };

  const handleConfirmExit = () => {
    setShowModal(false);
    navigate({ to: '/' }).catch(() => {});
  };

  return (
    <>
      <div className="toolbar" data-testid="toolbar">
        <button type="button" onClick={handleLogoClick} className="logos reset-button-styles" data-testid="logo">
          <img src={LogoDecat} alt="logo-decat" className="logo-decat" />
          <img src={LogoILink} alt="logo-ilink" />
        </button>

        <div className="user-preferences" data-testid="user-preferences">
          <LanguagePicker />
          <div className="user" data-testid="user">
            {userName}
          </div>
        </div>
      </div>

      <ConfirmationModal isOpen={showModal} onClose={() => setShowModal(false)} onConfirm={handleConfirmExit} />
    </>
  );
};
